

// import { useFormPreventaCorporativaInstalacion, useFormPreventaCorporativaServicio } from "@/erp/sale/asesor/preventa/shared/hook/useFormPreventaCorporativa";
import {
  gridSizeMdLg12,
  gridSizeMdLg3,
  gridSizeMdLg6,
  gridSizeMdLg9,
} from "@/shared";
import { useGetPlanCorporativo } from "@/shared/actions/erp/planes";
import {
  CustomAutocompleteArrString,
  CustomNumberTextField,
  CustomTextField,
  CustomTextFieldNoForm,
  CustomTextArea,
  DropzoneFiles,
  SampleCheckbox,
  SampleDatePicker,
} from "@/shared/components/ui";
import {
    CondicionVentaCorporativa,
  // PERMANENCIA_PLAN_CORPORATIVO_CHOICE,
  PlanesCorporativos,
  TIPO_PLAN_CORPORATIVO_CHOICE,
  TipoPlanCorporativo,
} from "@/shared/interfaces";
import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import { Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";

type Props = {
    form: UseFormReturn<IPreventaCorporativoForm2, any, IPreventaCorporativoForm2>;
    enableEdit?: boolean;
}

const SectionLinkDetails = ({
    form,
    enableEdit,

}: Props) => {

    ///* STATES ------------
    const [loadPlanesCorporativos, setLoadPlanesCorporativos] = useState(false);
    const [DataPlanSelected, setDataPlanSelected] = useState<PlanesCorporativos[]>([]);
    useEffect(() => {
        loadPlanCapacidadSelected()
    }, [form.watch().plan]);



    const {
    control,
    reset,
    formState: { errors },
    } = form;

    // const watcherTipoPlan = form.watch().tipo_plan
    const watcherPlan_personalizado = form.watch().plan_personalizado
    

    const valorInstalacion = form.watch().valor_instalacion

    const {
    data: dataPlanesCorporativos,
    // isLoading: isLoadingPlanesCorporativos,
    } = useGetPlanCorporativo(
    {
        page_size: 100,
        tipo_plan: form.watch().tipo_plan!,
    },
    loadPlanesCorporativos
    );

    useEffect(() => {
        // form.reset({
        //   ...form.getValues(),
        //   plan_personalizado:false,
        // })
        if (form.watch().tipo_plan) {
            setLoadPlanesCorporativos(true);
        }
    }, [form.watch().tipo_plan]);

    useEffect(() => {
        loadPlanCapacidadSelected()
    }, [form.watch().plan]);
    useEffect(() => {
        if(watcherPlan_personalizado){
            setDataPlanSelected([])
        }
    }, [watcherPlan_personalizado]);

    // const typInstalation = useTypeInstalation((s) => s.typInstalation);
    // const isLoadingTypeInstalation = useTypeInstalation(
    //   (s) => s.isLoadingTypeInstalation
    // );

    function loadPlanCapacidadSelected(){
    // if (form.watch().plan) {
        const auxDataPlanesCorporativos =
        dataPlanesCorporativos?.data.data.filter(
            (x) => x.codigo == form.getValues().plan
        );
        if (auxDataPlanesCorporativos && auxDataPlanesCorporativos.length>0) {
        const planCorporativo = auxDataPlanesCorporativos[0]
        reset({
            ...form.getValues(),
            data_plan_personalizado:{
            nombre_personalizado: form?.getValues()?.data_plan_personalizado?.nombre_personalizado,
            tipo_plan_personalizado: form.getValues()?.tipo_plan,
            permanencia_personalizado: planCorporativo?.permanencia || undefined,
            costo_instalacion_personalizado: form.getValues()?.data_plan_personalizado?.costo_instalacion_personalizado || planCorporativo?.costo_instalacion,
            valor_personalizado: planCorporativo?.valor,
            capacidad_personalizado: (planCorporativo?.capacidad)?.toString(),
            bonificacion_personalizado: form.getValues()?.data_plan_personalizado?.bonificacion_personalizado || 0,
            },
        })
        setDataPlanSelected(auxDataPlanesCorporativos);
        }
    // }
    }


    return (<>
    <Grid container {...gridSizeMdLg12} spacing={3} marginY={1}>
        {/* <Grid container item>
          <Typography variant="h6">Detalles del Servicio</Typography>
        </Grid> */}
        <CustomTextFieldNoForm
          size={gridSizeMdLg6}
          label={"Tipo de Contrato"}
          value={"CORPORATIVO"}
          disabled={true}
        />
        <CustomAutocompleteArrString
          size={gridSizeMdLg6}
          label={"Subtipo de Contrato"}
          name="tipo_plan"
          options={TIPO_PLAN_CORPORATIVO_CHOICE}
          defaultValue={form.getValues().tipo_plan}
          isLoadingData={false}
          control={control}
          error={form.formState.errors.tipo_plan}
          helperText={form.formState.errors.tipo_plan?.message}
          onChangeValue={(e) => {
            console.log({veamos:form.getValues()})
            setDataPlanSelected([]);
            reset({
              ...form.getValues(),
              tipo_plan: e,
              plan: "",
              data_plan_personalizado:{
                ...form.getValues().data_plan_personalizado,
                tipo_plan_personalizado:e
              },
              plan_personalizado:e==TipoPlanCorporativo.PYME||e==TipoPlanCorporativo.INSTITUCIONALES?false:true,

            });
          }}
          required={true}
          disabled={form.getValues()?.id_preventa_coorporativa?true:false}
        />
        {/* {
          form.getValues()?.plan && watcherTipoPlan==TipoPlanCorporativo.INSTITUCIONALES?
          null
          :
          <CustomAutocomplete<PlanesCorporativos>
            size={gridSizeMdLg6}
            label={`${watcherTipoPlan!=TipoPlanCorporativo.INSTITUCIONALES?"Enlace":"Plan"}`}
            name="plan"
            // ===================================================================
            // Para que solo muestre los que han sido creados
            // ===================================================================
            options={
              dataPlanesCorporativos?.data.data?.filter(x=>!x.plan_personalizado) || []
            }
            defaultValue={form.getValues().plan}
            isLoadingData={isLoadingPlanesCorporativos}
            control={form.control}
            error={form.formState.errors.plan}
            helperText={form.formState.errors.plan?.message}
            valueKey="nombre" // name is the fk
            actualValueKey="codigo"
            onChangeRawValue={(value) => {
              // loadPlanCapacidadSelected()
              // alert(!watcherPlan_personalizado)
              !watcherPlan_personalizado?
                reset({
                  ...form.getValues(),
                  valor_instalacion: value.costo_instalacion,
                  capacidad: value?.capacidad?.toString(),
                  valor_plan: value.valor,
                  velocidad_total: (parseFloat(`${value?.capacidad||"0"}`)+parseFloat(form.getValues()?.bonificacion||"0"))?.toString()
                  
                })
              :
              reset({
                ...form.getValues(),
                plan:undefined,
              })
            }}
            disabled={watcherPlan_personalizado || !enableEdit}
          />
        } */}

        {/* {
          (watcherTipoPlan!=TipoPlanCorporativo.PYME && watcherTipoPlan!=TipoPlanCorporativo.INSTITUCIONALES) && watcherTipoPlan ?
          <>
            <SampleCheckbox
              size={gridSizeMdLg12}
              label='Enlace Personalizada'
              control={form.control}
              name='plan_personalizado'
              defaultValue={form.getValues().plan_personalizado!}
              onChangeValue={(e) => {
                e?
                form.reset({ ...form.getValues(), 
                  plan_personalizado: e
                })
                :
                form.reset({ ...form.getValues(), 
                  plan_personalizado: e,
                  plan:"",
                  capacidad:"",
                  data_plan_personalizado:{
                    nombre_personalizado: "",
                    tipo_plan_personalizado: undefined,
                    permanencia_personalizado: undefined,
                    costo_instalacion_personalizado: undefined,
                    valor_personalizado: undefined,
                    capacidad_personalizado: undefined,
                  
                    bonificacion_personalizado:undefined,
                  },
                })
              }}
              disabled={enableEdit 
                || form.getValues()?.prospecto_corporativo_data?.condicion_venta==CondicionVentaCorporativa.CANJE}
            />
          </>
          :null
        } */}
        
      </Grid>

      <Grid
        
        container
        spacing={3}
        {...gridSizeMdLg12}
        justifyContent={"start"}
        alignContent={"start"}
        marginY={1}
      >
        <CustomTextFieldNoForm
          label={`Nombre de Enlace`}
          // label={`Nombre de ${watcherTipoPlan!=TipoPlanCorporativo.PYME && watcherTipoPlan!=TipoPlanCorporativo.INSTITUCIONALES?"Enlace":"Plan"}`}
          value={
            // watcherPlan_personalizado?
            form.getValues().data_plan_personalizado?.nombre_personalizado 
            // :DataPlanSelected?.[0]?.nombre || ""
          }
          required={true}
          size={gridSizeMdLg6}
          shrink={!!form.getValues().data_plan_personalizado?.nombre_personalizado}
          // disabled={
          //   watcherPlan_personalizado?false
          //   :enableEdit?true:false}
          onChangeCustom={(value)=>{
            form.reset({
              ...form.getValues(),
              data_plan_personalizado:{
                ...form.getValues().data_plan_personalizado,
                nombre_personalizado:value.target.value.toUpperCase()
              }
            })
            
          }}
        />

        {
          // watcherPlan_personalizado?
          // <Custom
          //   label={`Tipo de ${watcherTipoPlan!=TipoPlanCorporativo.PYME?"Enlace":"Plan"}`}
          //   size={gridSizeMdLg6}
          //   name="tipo_plan"
          //   options={TIPO_PLAN_CORPORATIVO_CHOICE}
          //   defaultValue={form.getValues().tipo_plan}
          //   isLoadingData={false}
          //   control={control}
          //   error={form.formState.errors.tipo_plan}
          //   helperText={form.formState.errors.tipo_plan?.message}
          //   disabled={true}
          //   onChangeValue={(e) => {
          //     console.log(e)
          //     setDataPlanSelected([]);
          //     reset({
          //       ...form.getValues(),
          //       tipo_plan: e,
          //       plan: "",
          //       data_plan_personalizado:{
          //         ...form.getValues().data_plan_personalizado,
          //         tipo_plan_personalizado:e
          //       }
          //     });
          //   }}
          // />
          // :
          // <CustomTextFieldNoForm
          //   label={`Tipo de ${watcherTipoPlan!=TipoPlanCorporativo.PYME && watcherTipoPlan!=TipoPlanCorporativo.INSTITUCIONALES?"Enlace":"Plan"}`}
          //   value={watcherTipoPlan? form.getValues().tipo_plan :DataPlanSelected?.[0]?.tipo_plan || ""}
          //   size={gridSizeMdLg6}
          //   shrink={!!DataPlanSelected?.[0]?.tipo_plan}
          //   disabled={true}
          // />
        }
        <Grid container item {...gridSizeMdLg6}>
          <CustomNumberTextField
            label="Tiempo de Permanencia"
            name="permanencia"
            control={form.control}
            error={undefined}
            helperText={undefined}
            defaultValue={ form.getValues()?.plan_data?.permanencia || form.getValues().data_plan_personalizado?.permanencia_personalizado}
            size={gridSizeMdLg9}
            onChangeValue={(value)=>{
              form.reset({
                ...form.getValues(),
                data_plan_personalizado:{
                  ...form.getValues().data_plan_personalizado,
                  permanencia_personalizado:`${value} MESES`
                }
              })
            }}
            disabled={!enableEdit}
            required={false}
          />
          <Grid container item {...gridSizeMdLg3} alignContent={"center"} justifyContent={"center"}>
            <Typography variant="subtitle1">
              MESES
            </Typography>
          </Grid>
        </Grid>
        {
          // watcherPlan_personalizado?
          // <CustomAutocompleteArrString
          //   label="Permanencia"
          //   name="permanencia"
          //   control={form.control}
          //   error={undefined}
          //   isLoadingData={false}
          //   helperText={undefined}
          //   options={PERMANENCIA_PLAN_CORPORATIVO_CHOICE}
          //   defaultValue={ form.getValues()?.plan_data?.permanencia || form.getValues().data_plan_personalizado?.permanencia_personalizado}
          //   size={gridSizeMdLg6}
          //   onChangeValue={(value)=>{
          //     form.reset({
          //       ...form.getValues(),
          //       data_plan_personalizado:{
          //         ...form.getValues().data_plan_personalizado,
          //         permanencia_personalizado:value
          //       }
          //     })
          //   }}
          //   disabled={!enableEdit}
          //   required={false}
          // />
          // :
          // <CustomTextFieldNoForm
          //   value={DataPlanSelected?.[0]?.permanencia || ""}
          //   size={gridSizeMdLg6}
          //   label={"Tiempo de Permanencia"}
          //   shrink={!!DataPlanSelected?.[0]?.permanencia}
          //   disabled={true}
          //   required={false}
          // />
        }
        
        <CustomTextFieldNoForm
          label={"Enlace (Mbps)"}
          value={
            form.getValues().data_plan_personalizado?.capacidad_personalizado || form.getValues()?.plan_data?.capacidad ||"" 
          }
          size={gridSizeMdLg3}
          shrink={!!DataPlanSelected?.[0]?.capacidad}
          required={true}
          // disabled={enableEdit}
          enableOnlyNumber={true}
          onChangeCustom={(value)=>{
            const auxValue = isNaN(parseFloat(value.target.value))?0:parseFloat(value.target.value)
            const velocidadTotal = auxValue + parseFloat(form.getValues().bonificacion||"0")
            form.reset({
              ...form.getValues(),
              capacidad:auxValue.toString(),
              velocidad_total: form.getValues().bonificacion ?velocidadTotal.toString():auxValue.toString(),
              data_plan_personalizado:{
                ...form.getValues().data_plan_personalizado,
                capacidad_personalizado:auxValue.toString()||"0"
              }
            })
          }}
        />
        <CustomNumberTextField
          label={'Bonificación Deseada (Mbps)'}
          control={control}
          name="bonificacion"
          defaultValue={form.getValues().bonificacion}
          size={gridSizeMdLg3}
          error={errors.bonificacion}
          helperText={errors.bonificacion?.message}
          onlyInteger
          min={0}
          onChangeValue={(e) => {
            const auxValue = isNaN(parseFloat(e))?0:parseFloat(e)
            const velocidadTotal = auxValue + parseFloat(form.getValues().data_plan_personalizado?.capacidad_personalizado||"0") 
            reset({
              ...form.getValues(),
              bonificacion:auxValue?.toString(),
              velocidad_total: velocidadTotal.toString(),// : DataPlanSelected?.[0]?.capacidad.toString(),
              data_plan_personalizado:{
                ...form.getValues().data_plan_personalizado,
                bonificacion_personalizado:auxValue
              }
            })
          }}
          disabled={!enableEdit}
        />
        <CustomTextField
          label={"Velocidad Total"}
          name="velocidad_total"
          defaultValue={form.getValues().velocidad_total}
          size={gridSizeMdLg6}
          shrink={!!form.getValues().velocidad_total}
          control={control}
          error={errors.velocidad_total}
          helperText={errors?.velocidad_total?.message}
          disabled={true}
        />
        <CustomNumberTextField
          label={'Valor Mensual ($)'}
          control={control}
          name="valor_plan"
          defaultValue={form.getValues().valor_plan}
          size={gridSizeMdLg6}
          error={errors.valor_plan}
          helperText={errors.valor_plan?.message}
          required={false}
          onChangeValue={(value) => {
            form.reset({
              ...form.getValues(),
              valor_plan:parseFloat(value||"0"),
              data_plan_personalizado:{
                ...form.getValues().data_plan_personalizado,
                valor_personalizado:parseFloat(value||"0")
              }
            })
          }}
          disabled={!enableEdit}
        />
        {/* {
          watcherPlan_personalizado && form.getValues().condicion_venta==CondicionVentaCorporativa.CANJE?
          null
          :
          <CustomTextFieldNoForm
            label={watcherPlan_personalizado?"Valor Instalación":"Valor Instalación Referencial"}
            value={watcherPlan_personalizado?
              form.getValues().data_plan_personalizado?.costo_instalacion_personalizado ||"0" 
              :DataPlanSelected?.[0]?.costo_instalacion || ""}
            size={
              // (watcherTipoPlan!=TipoPlanCorporativo.PYME && watcherTipoPlan!=TipoPlanCorporativo.INSTITUCIONALES) && watcherTipoPlan?
              gridSizeMdLg6
              // :gridSizeMdLg3
            }
            shrink={!!DataPlanSelected?.[0]?.costo_instalacion}
            disabled={watcherPlan_personalizado?false
              :enableEdit?true:false}
            enableOnlyNumber={true}
            onChangeCustom={watcherPlan_personalizado?(value)=>{
              form.reset({
                ...form.getValues(),
                valor_instalacion:parseFloat(value.target.value||"0"),
                data_plan_personalizado:{
                  ...form.getValues().data_plan_personalizado,
                  costo_instalacion_personalizado:parseFloat(value.target.value||"0")
                }
              })
              
            }:undefined}
          />
        } */}
        {
          watcherPlan_personalizado && form.getValues().condicion_venta==CondicionVentaCorporativa.CANJE?
          null
          :
          <CustomNumberTextField
            label={'Valor de Instalación ($)'}
            control={control}
            name="valor_instalacion"
            defaultValue={valorInstalacion || 0}
            required={false}
            size={gridSizeMdLg6}
            error={errors.valor_instalacion}
            helperText={errors.valor_instalacion?.message}
            onChangeValue={val=>{
              form.reset({
                ...form.getValues(),
                valor_instalacion:parseFloat(val||"0"),
                data_plan_personalizado:{
                  ...form.getValues().data_plan_personalizado,
                  costo_instalacion_personalizado:parseFloat(val||"0")
                }
              })
            }}
            disabled={!enableEdit}
          />
        }
      </Grid>

      <Grid
        marginY={1}
        container
        spacing={3}
        {...gridSizeMdLg12}
        justifyContent={"start"}
        alignContent={"start"}
      >
        {
          form.getValues().tipo_plan != TipoPlanCorporativo.BACKUP_CON_COSTO &&
          (
            <>
              <CustomTextField
                label={"Disponibilidad"}
                name="disponibilidad"
                defaultValue={"99.6"}
                size={gridSizeMdLg6}
                shrink={!!form.getValues().disponibilidad}
                control={control}
                error={errors.disponibilidad}
                helperText={errors?.disponibilidad?.message}
                disabled={true}
                required={false}
              />
              <SampleCheckbox
                size={gridSizeMdLg6}
                label='Incluye Backup'
                control={form.control}
                name='aumentar_disponibilidad'
                defaultValue={form.getValues()?.disponibilidad=="99.8"?true:false}
                onChangeValue={(e) => {
                  form.reset({ ...form.getValues(),
                    aumentar_disponibilidad: e,
                    requiere_backup: e,
                    disponibilidad: e?"99.8":"99.6"
                  })
                }}
              />
              {
                form.getValues()?.aumentar_disponibilidad &&
                <CustomTextArea
                  label="Observación Enlace Backup"
                  name="observacion_enlace_backup"
                  typeOfEntry={'observacion'}
                  autoGrow
                  maxRows={14}
                  control={form.control}
                  defaultValue={
                    form.getValues()?.observacion_enlace_backup
                    || form.getValues()?.observaciones?.observacion_enlace_backup
                    || ""
                  }
                  sxTextField={{
                    border: '2px solid #d1d1d1',
                    borderRadius: '10px',
                  }}
                  required={false}
                  helperText={form.formState.errors.observacion_enlace_backup?.message}
                  error={form.formState.errors.observacion_enlace_backup}
                />
              }
            </>
          )
        }
        {/* <Grid {...gridSizeMdLg6} item container spacing={2}>
        </Grid> */}
        {/* {
          form.getValues()?.tipo_plan==TipoPlanCorporativo.DEMO?
          <SampleCheckbox
            size={gridSizeMdLg6}
            label='Incluye Back Up'
            control={form.control}
            name='requiere_backup'
            defaultValue={form.getValues().requiere_backup!}
            onChangeValue={(e) => {
              form.reset({ ...form.getValues(), 
                requiere_backup: e
              })
            }}
          />
          :null
        } */}


        {
          // form.getValues().tipo_plan==TipoPlanCorporativo.DEMO
          form.getValues().tipo_plan 
          && (
            form.getValues().tipo_plan?.includes("DEMO")
            || form.getValues().tipo_plan?.includes("EVENTO")
            || form.getValues().tipo_plan?.includes("CANJE")
          )
          ?
            <Grid item container spacing={2} justifyContent={'start'} alignContent={'start'} {...gridSizeMdLg12}>
              <SampleDatePicker
                label="Fecha Inicio Plan"
                name="fecha_inicio_plan"
                control={form.control}
                defaultValue={dayjs().format()}
                error={form.formState.errors.fecha_inicio_plan}
                helperText={form.formState.errors.fecha_inicio_plan?.message}
                minDate={ dayjs()}
                size={gridSizeMdLg6}
              />
              <SampleDatePicker
                label="Fecha Fin Plan"
                name="fecha_fin_plan"
                control={form.control}
                defaultValue={dayjs().format()}
                error={form.formState.errors.fecha_fin_plan}
                helperText={form.formState.errors.fecha_fin_plan?.message}
                minDate={ dayjs()}
                size={gridSizeMdLg6}
              />
              {/* <CustomTextField
                control={control}
                shrink={true}
                type="date"
                name="fecha_inicio_plan"
                defaultValue={formatDate(form.getValues().fecha_inicio_plan!) || ''}
                size={gridSizeMdLg6}
                label={"FECHA INICIO EVENTO"}
                error={errors.fecha_inicio_plan}
                helperText={errors.fecha_inicio_plan?.message} />
              <CustomTextField
                control={control}
                shrink={true}
                type="date"
                name="fecha_fin_plan"
                defaultValue={form.getValues().fecha_fin_plan?.toString() || ''}
                size={gridSizeMdLg6}
                label={"FECHA FIN EVENTO"}
                error={errors.fecha_fin_plan}
                helperText={errors.fecha_fin_plan?.message} /> */}
            </Grid>
          :null
        }


      <Grid item container spacing={2} justifyContent={'start'} alignContent={'start'} {...gridSizeMdLg12}>
        
        <SampleCheckbox
          size={gridSizeMdLg3}
          label='Energía Regulada'
          control={form.control}
          name='energia_regulada'
          defaultValue={form.getValues().energia_regulada || false}
          onChangeValue={(e) => {
            form.reset({ ...form.getValues(), energia_regulada: e })
          }}
          disabled={!enableEdit}
        />
        <SampleCheckbox
          size={gridSizeMdLg3}
          label='Espacio Para Equipos'
          control={form.control}
          name='espacio_equipos'
          defaultValue={form.getValues().espacio_equipos || false}
          onChangeValue={(e) => {
            form.reset({ ...form.getValues(), espacio_equipos: e })
          }}
          disabled={!enableEdit}
        />
        <SampleCheckbox
          size={gridSizeMdLg3}
          label='Zona Soterrada'
          control={form.control}
          name='zona_soterrada'
          defaultValue={form.getValues().zona_soterrada || false}
          onChangeValue={(e) => {
            form.reset({ ...form.getValues(), zona_soterrada: e })
          }}
          disabled={!enableEdit}
        />
        <SampleCheckbox
          size={gridSizeMdLg3}
          label='Instalación por Ductos'
          control={form.control}
          name='instalacion_ductos'
          defaultValue={form.getValues().instalacion_ductos || false}
          onChangeValue={(e) => {
            form.reset({ ...form.getValues(), instalacion_ductos: e })
          }}
          disabled={!enableEdit}
        />
      </Grid>

      <Grid item container spacing={2} 
      justifyContent={'start'} alignContent={'start'} {...gridSizeMdLg12}>
        <DropzoneFiles form={form}/>

      </Grid>


    </Grid>

  </>)
}

export default SectionLinkDetails